import urlPaths from 'static/constants/enums/urlPaths';

export const ignoredRoutes: string[] = [
    urlPaths.start,
    urlPaths.initialLoadAndCreate,
    urlPaths.loadOpportunity,
    urlPaths.returningOpportunity,
    urlPaths.error,
];
